angular.module('picmonicng').directive('infiniteScrollPage', [
  'LearnService',
  '$filter',
  '$window',
  function (LearnService, $filter, $window) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.offset = 0;
        scope.calc_offset = 0;
        scope.item_height = attrs.itemHeight;
        var top = element.offset().top;

        var timeout;
        $(window).bind('scroll', function (event) {
          scope.$apply(function () {
            scope.scrolling = true;
            scope.offset = Math.floor(Math.max(0, document.body.scrollTop - top) / scope.item_height);
          });

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            scope.$apply(function () {
              scope.scrolling = false;
            });
          }, 150);
        });

        function setDimensions() {
          scope.limit = Math.ceil(window.innerHeight / scope.item_height) + 5;
        }

        angular.element($window).bind('resize', function () {
          setDimensions();
          scope.$apply();
        });

        setDimensions();
      },
    };
  },
]);
